import { useContext } from 'react'
import { RedirectContext, RedirectContextValues } from './context'

export const useRedirect = (): RedirectContextValues => {
  return useContext(RedirectContext)
}
